import { imgApi } from "../services/ImgApi.js";
import { utils } from "../services/Utils";
export const rilieviUtils = {
    getInterni,buildNcFromRilievi,getFoto
};
function buildNcFromRilievi(listaRilieviAll,r,prgAc,acDes){
    if (r==null){
        r=listaRilieviAll[0];
    }
    var nc={desNN:'',prgAc:0,desAc:'', interni: [], foto: [], variazioni: '', msgNc: '' };
        nc.desNN=r.desNN;
        nc.prgAc=prgAc;
        nc.desAc=acDes;
        nc.id=r.uniqueId;
        nc.latLng=r.latLng;
        nc.interni=getInterni(listaRilieviAll,r);
      return nc;
}

function getDesLoc(l){
    if (l.mappedTipoAna=='PR' || l.mappedTipoAna=='IMP'){
      return l.mappedDesAna;

    }else if (l.mappedTipoAna=='VR'){
      return getDesVr(l);
    }else{
      return l.mappedCodAna;
    }
  }
  function getDesVr(p) {
      return p.mappedDesAna + " - " + p.vr.desAc;
    
  }
  function getRilieviCollegati(allRilievi,r){
    var rilCollegati = [];
    allRilievi.forEach(element => {
        if (element.ncNuovo==r.ncNuovo && element.ncNuovoSub==r.ncNuovoSub){
            rilCollegati.push(element);
        }
    });
    

    return rilCollegati;
  }
  function getInterno(r){
    var interno={};
    interno.desIN=utils.formatInterno(r.intNuovo,r.intNuovoSub);
    interno.codUso=r.uso;
    //locatari
    var locatari=[];
    interno.locatari=locatari;
    var proprietari=[];
    interno.proprietari=proprietari;
    r.children.forEach(child => {
      if (child.indLocPropAmm=='LOC'){
        var loc={};
        loc.prgLocatario=child.id;
        loc.desLoc=getDesLoc(child);
        locatari.push(loc);
      }else  if (child.indLocPropAmm=='PROP'){
        var prop={};
        prop.prgProprietario=child.id;
        prop.desProp= getDesLoc(child);
        proprietari.push(prop);
      }
      
    });
    return interno;
  }
  function getInterni(list,r){
    var interni=[];
    var rilCollegati = getRilieviCollegati(list,r);
    rilCollegati.forEach(int => {
      interni.push(getInterno(int));
    });

    return interni;
  }
  async function getFoto(uniqueId){
      
    let x = await imgApi.getImgRiievo( uniqueId);
    
      var foto=[];

      for (let index = 0; index < x.length; index++) {
        const element = x[index];
        let image = {};
        image.url = element.url 
        
        foto.push(image);
      }
      return foto;
      
  }
